import {$intent} from '../intent/constants';
import {shallowEqualArray} from '../util';
import type {View} from './types';

type IntentEntry<Props> = View.Intent<Props> | null | undefined | false;

function areIntentsEqual<Props>(
  previous: IntentEntry<Props>,
  next: IntentEntry<Props>,
): boolean {
  if (Object.is(previous, next)) {
    return true;
  }
  if (!previous || !next) {
    return false;
  }

  return (
    previous[$intent] === next[$intent] &&
    Array.isArray(previous) &&
    Array.isArray(next) &&
    shallowEqualArray(previous, next)
  );
}

/**
 * Compares normalized intent arrays without hiding reactive changes.
 * Regenerated array intents can reuse identity only when their type and every
 * captured input are unchanged. Other regenerated intent shapes stay distinct.
 */
export function areIntentArraysEqual<Props>(
  previous: IntentEntry<Props>[],
  next: IntentEntry<Props>[],
): boolean {
  if (Object.is(previous, next)) {
    return true;
  }
  if (previous.length !== next.length) {
    return false;
  }

  for (let i = 0; i < previous.length; i++) {
    if (!areIntentsEqual(previous[i], next[i])) {
      return false;
    }
  }
  return true;
}
